import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Valores padrão (fallback)
const defaultSettings = {
  site_email: 'contato@disneylandia.com',
  site_phone: '(94) 99166-6990',
  site_whatsapp: '5594991666990',
  site_address: 'Av. Weyne Cavalcante, 720 - Canaã dos Carajás, PA',
  site_instagram: '@disneylandiacosmeticoscanaa',
  hero_indicator1_title: 'Beleza',
  hero_indicator1_subtitle: 'Cosméticos Premium',
  hero_indicator2_title: '100+',
  hero_indicator2_subtitle: 'Produtos',
  hero_indicator3_title: '100%',
  hero_indicator3_subtitle: 'Originais',
  hero_indicator4_title: 'Presentes',
  hero_indicator4_subtitle: 'Para Toda Ocasião'
};

const SiteSettingsContext = createContext(null);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/settings`);
        if (response.data) {
          setSettings(prev => ({ ...prev, ...response.data }));
        }
      } catch (error) {
        console.log('Usando configurações padrão');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const refreshSettings = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/settings`);
      if (response.data) {
        setSettings(prev => ({ ...prev, ...response.data }));
      }
    } catch (error) {
      console.error('Erro ao atualizar configurações:', error);
    }
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings deve ser usado dentro de SiteSettingsProvider');
  }
  return context;
};
